import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANTS } from '../../constants';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-tradeboard',
  templateUrl: './tradeboard.component.html',
  styleUrls: ['./tradeboard.component.scss']
})
export class TradeboardComponent implements OnInit {

  constructor(
    private router: Router,
    private dataService: DataService
  ) { }

  tradeboards: any = [];
  ngOnInit(): void {
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.TRADEBOARD});
    this.dataService.onTradeboardOpened.subscribe(tbs => {
      let tb_list: any = [];
      for (let idx = 0; idx < tbs.length; idx ++) {
        let name = tbs[idx].name.replace(" ", "_");
        tb_list.push({
          id: name,
          target: name,
          name: name,
          content_id: `${name}-content`,
          content: tbs[idx],
          active: (idx == 0) ? {active:1} : {active:0}
        });
      }
      this.tradeboards = tb_list;
    });
    this.parseData();
  }

  parseData() {
    let received_tradeboard: any = null;
    if (this.router.getCurrentNavigation()?.extras.state) {
      let routeState: any = this.router.getCurrentNavigation()?.extras.state;
      if (routeState) {
        received_tradeboard = routeState.tradeboard;
      }
    } else {
      if (window.history.state.tradeboard) {
        received_tradeboard = window.history.state.tradeboard;
        received_tradeboard.edit_mode = true;
        this.dataService.tradeboardOpened(received_tradeboard);
      } else {
        if (window.history.state.add) {
          this.dataService.addTmpTradeboard();
        } else {
          this.router.navigate(['/tah', 'tblist']);
        }
      }
    }
  }
}
